import BaseModal from "@components/BaseModal";
import PropTypes from "prop-types";
import {ErrorBoundary} from "react-error-boundary";
import {useTranslation} from "react-i18next";
import {PrimaryButton} from "@/components/Button";
import {captureSentryException} from "../../../Infra/monitoring/sentry.ts";
import {useLogo} from "../../../util/logoUtils";
import styles from "../ErrorBoundaryHandler.module.css";

const ErrorBoundaryAppFallback = ({resetErrorBoundary}) => {
  const {t} = useTranslation();
  const logoImg = useLogo(); // Dynamic logo based on hostname

  const handleErrorState = () => {
    window.location.href = "/";
    resetErrorBoundary();
  };

  return (
    <BaseModal
      open={true}
      footer={null}
      closable={false}
      centered
      width={555}
      styles={{
        body: {
          padding: window.innerWidth <= 768 ? "32px 0px 24px 0px" : "32px 32px 24px 32px",
          borderRadius: 16,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        },
      }}
    >
      <div className={styles.error_boundary_container}>
        <img
          src={logoImg}
          alt="Logo"
          className={styles.errorBoundaryLogoImg}
        />
        <p className={styles.error_boundary_title}>{t("errorBoundaryAPPMessage1")}</p>
        <p style={{fontSize: "16px", textAlign: "center"}}>{t("errorBoundaryAPPMessage2")}</p>

        <PrimaryButton
          onClick={handleErrorState}
          style={{marginTop: 30}}
        >
          {t("errorBoundaryBtnReload")}
        </PrimaryButton>
      </div>
    </BaseModal>
  );
};

export const ErrorBoundaryApp = ({children}) => {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorBoundaryAppFallback}
      onError={error => captureSentryException(error)}
    >
      {children}
    </ErrorBoundary>
  );
};

ErrorBoundaryApp.propTypes = {
  children: PropTypes.node,
  error: PropTypes.any,
};
